import React, { useState } from "react";
import { currentUserService } from "../api/services";
import { User } from "../models";

export interface CurrentUserContextProps {
    currentUser?: User;
    getCurrentUser: () => Promise<void>;
};

export const CurrentUserContext = React.createContext({} as CurrentUserContextProps);

export const CurrentUserStore: React.FC = props => {

    const [currentUser, setCurrentUser] = useState<User>();

    const onGetCurrentUser = async () => {
        const model = await currentUserService.getCurrentUser();
        setCurrentUser(model);
    };

    return (
        <CurrentUserContext.Provider value={{ currentUser: currentUser, getCurrentUser: onGetCurrentUser }}>
            {props.children}
        </CurrentUserContext.Provider>
    );
};
